import * as React from 'react';
import { InfoWindow, Marker } from 'react-google-maps';

import { IPlace } from '../models/place';
import { IResort } from '../models/resort';

import { getLocale } from '../../utils/pathHelper';

// (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+
const iconTypes = {
  dot: {
    path: 'm -5, 0 a 5,5 0 1,0 10,0 a 5,5 0 1,0 -10,0',
    fillColor: '#007bff',
    fillOpacity: 0.6,
    strokeColor: '#007bff',
    strokeOpacity: 0.9,
    strokeWeight: 1,
    scale: 1,
  },
};

interface IMapMarker {
  iconType?: 'dot';
  isOpen: boolean;
  handleClick: () => void;
  place: IPlace|IResort;
}

const renderContent = (place: IPlace|IResort) => {
  const title = place[`name_${getLocale({ underscore: true })}`] || 'unknown';
  const resortCode = (place as IResort).resort_code;
  if (resortCode) {
    return (
      <a href={`/snow/resorts/${resortCode}`}>
        {title}
      </a>
    );
  }
  return title;
}

const MapMarker = ({ iconType, isOpen, handleClick, place }: IMapMarker) => {
  const position = { lat: Number(place.latitude), lng: Number(place.longitude) };
  const title = place.name_ja;
  const icon = iconTypes[iconType] || '';
  return (
    <React.Fragment>
      {isOpen &&
        <InfoWindow position={position}>
          <div className="resort-search__infowindow">
            {renderContent(place)}
          </div>
        </InfoWindow>
      }
      <Marker position={position} onClick={handleClick} icon={icon} />
    </React.Fragment>
  );
}

export default MapMarker;
